export default "__VITE_ASSET__BlBTpCVv__"